import { CourseFormat } from './interface/BaseInterface'

export const API_URL = process.env.VUE_APP_API_URL as string

export const courseFormat: CourseFormat[] = ['IELTS']

export const fileAccept = [
  'application/msword',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.ms-powerpoint',
  'text/plain',
  'application/pdf',
  '.doc',
  '.docx',
  'application/zip',
  'application/rar'
]

export const imageAccept = ['image/png', 'image/jpeg']

export const videoAccept = ['video/mp4', 'video/MP4V-ES', 'video/quicktime', 'video/x-flv', 'video/x-msvideo', 'video/x-ms-wmv']

export const audioAccept = ['audio/*']

export const localRole: Record<string, string> = {
  admin: 'ADMIN',
  member: 'MEMBER'
}

export const courseRole: Record<string, string> = {
  admin: 'COURSE_ADMIN',
  teacher: 'COURSE_TEACHER',
  member: 'COURSE_MEMBER'
}
